<script setup>
import { computed,} from 'vue';
import { useStore } from 'vuex'

const store = useStore()

const input_remarks = computed({
  get:() => store.state.trafficRecordComponent.input_remarks,
  set:(val) => store.commit('trafficRecordComponent/SET_INPUT_REMARKS',val)
});

const loading = computed(() => store.state.globals.loading);

</script>

<template>
    <div class="col-12 col-lg-5 mb-1">
        <b-overlay :show="loading">
            <div class="card">
                <div class="card-body overflow-auto">
                    <div class="form-group">
                        <label for="remarks" class="text-bold">Remarks</label>
                        <textarea class="form-control" id="remarks" rows="3" v-model="input_remarks"></textarea>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>
